<template>
  <v-hover>
          <v-expansion-panel
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 5 : 2}`"
            class="mb-3 parent-expansion withRemove"
            style="position:relative">
              <div class="horiz-left-coloured-bg">
                    <v-icon color="secondary" class="mt-0 ml-2 horiz-left-coloured-bg--icon">access_alarm</v-icon>
              </div>
              <v-expansion-panel-content class="rounded-3">
                <div slot="header">
                  <h3
                  class="text-truncate py-1 ml-2 pl-4 horiz-left-coloured-bg--padding-header">{{name}}</h3>
            <v-btn @click.stop="deleteSLA()" class="expansion-remove-btn" icon>
              <v-icon color="error">cancel</v-icon>
            </v-btn>
        </div>
        <v-layout class="horiz-left-coloured-bg--padding">
          <v-flex px-4 pb-4>
            <form>
              <v-layout wrap row class="pa-0 mt-3">
                <v-flex xs12 sm6>
                  <v-text-field v-model="name" label="Service Level Title" box></v-text-field>
                  <v-select
                    v-model="bucketId"
                    :items="buckets"
                    item-text="name"
                    item-value="id"
                    box
                    label="Select a bucket"
                    dense
                    append-icon="keyboard_arrow_down">
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap fluid>
                    <v-flex xs12 md6>
                      <h4 class="pb-1">In jeopardy after...</h4>
                      <v-select
                        v-model="jeopardyDays"
                        :items="dayOptions"
                        box
                        label="Days"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block; margin-right:12px;">
                      </v-select>
                      <v-select
                        v-model="jeopardyHours"
                        :items="hourOptions"
                        box
                        label="Hrs"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block;margin-right:12px;">
                      </v-select>
                      <v-select
                        v-model="jeopardyMinutes"
                        :items="minuteOptions"
                        box
                        label="Mins"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block">
                      </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
                      <h4 class="pb-1 pl-1">Then run this task...</h4>
                      <v-select
                        v-model="jeopardyTask"
                        :items="tasks"
                        item-text="description"
                        item-value="id"
                        box
                        label="Select a task"
                        dense
                        append-icon="keyboard_arrow_down"
                        :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-1': $vuetify.breakpoint.mdAndUp}">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap fluid>
                    <v-flex xs12 md6>
                      <h4 class="pb-1">In breach after...</h4>
                      <v-select
                        v-model="breachDays"
                        :items="dayOptions"
                        box
                        label="Days"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block; margin-right:12px;">
                      </v-select>
                      <v-select
                        v-model="breachHours"
                        :items="hourOptions"
                        box
                        label="Hrs"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block;margin-right:12px;">
                      </v-select>
                      <v-select
                        v-model="breachMinutes"
                        :items="minuteOptions"
                        box
                        label="Mins"
                        dense
                        append-icon="keyboard_arrow_down"
                        style="width:calc(33.33% - 8px); display:inline-block">
                      </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
                      <h4 class="pb-1 pl-1">Then run this task...</h4>
                      <v-select
                        v-model="breachTask"
                        :items="tasks"
                        item-text="description"
                        item-value="id"
                        box
                        label="Select a task"
                        dense
                        append-icon="keyboard_arrow_down"
                        :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-1': $vuetify.breakpoint.mdAndUp}">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-switch
                  color="secondary"
                  label="Turn on this service level"
                  v-model="enabled"
                  class="mb-0 mt-0">
                </v-switch>
                <v-flex xs12>
                  <v-btn @click="updateSLA" :disabled="!serviceLevelUpdated" class="ml-0" color="success">Save Changes</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-hover>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "service-level",
  props: ["slaIndex", "sla"],
  data: () => {
    return {
      serviceLevelName: "",
      serviceLevelBucket: 0,
      serviceLevelJeopardyThreshold: { days: 0, hours: 0, minutes: 0, taskId: 0 },
      serviceLevelBreachThreshold: { days: 0, hours: 0, minutes: 0, taskId: 0 },
      serviceLevelEnabled: false,
      serviceLevelUpdated: false,
      addServiceLevelButton: true,
      addServiceLevelForm: false
    }
  },
  computed: {
    ...mapState({
      caseTypes: state => (state.caseTypes && Array.isArray(state.caseTypes.all) ? state.caseTypes.all : [])
    }),
    dayOptions() {
      const days = []
      for (let i = 0; i < 101; i++) { days.push((i)) }
      return days
    },
    hourOptions() {
      const hours = []
      for (let i = 0; i < 25; i++) { hours.push((i)) }
      return hours
    },
    minuteOptions() {
      const minutes = []
      for (let i = 0; i < 61; i++) { minutes.push((i)) }
      return minutes
    },
    bucketId: {
      get() {
        if (this.serviceLevelBucket) { return this.serviceLevelBucket }
        if (this.sla) { return this.sla.bucketId }
        return 0
      },
      set(newId) {
        this.serviceLevelBucket = newId
      }
    },
    name: {
      get() {
        if (this.serviceLevelName) { return this.serviceLevelName }
        if (this.sla) { return this.sla.name }
        return ""
      },
      set(newName) {
        this.serviceLevelName = newName
        this.serviceLevelUpdated = true
      }
    },
    jeopardyDays: {
      get() {
        return this.thresholdValue(this.serviceLevelJeopardyThreshold, this.sla && this.sla.inJeopardyThreshold, "days")
      },
      set(newDays) {
        this.serviceLevelJeopardyThreshold.days = newDays
        this.serviceLevelUpdated = true
      }
    },
    jeopardyHours: {
      get() {
        return this.thresholdValue(this.serviceLevelJeopardyThreshold, this.sla && this.sla.inJeopardyThreshold, "hours")
      },
      set(newHrs) {
        this.serviceLevelJeopardyThreshold.hours = newHrs
        this.serviceLevelUpdated = true
      }
    },
    jeopardyMinutes: {
      get() {
        return this.thresholdValue(this.serviceLevelJeopardyThreshold, this.sla && this.sla.inJeopardyThreshold, "minutes")
      },
      set(newMins) {
        this.serviceLevelJeopardyThreshold.minutes = newMins
        this.serviceLevelUpdated = true
      }
    },
    jeopardyTask: {
      get() {
        return this.thresholdValue(this.serviceLevelJeopardyThreshold, this.sla && this.sla.inJeopardyThreshold, "taskId")
      },
      set(newTask) {
        this.serviceLevelJeopardyThreshold.taskId = newTask
        this.serviceLevelUpdated = true
      }
    },
    breachDays: {
      get() {
        return this.thresholdValue(this.serviceLevelBreachThreshold, this.sla && this.sla.inBreachThreshold, "days")
      },
      set(newDays) {
        this.serviceLevelBreachThreshold.days = newDays
        this.serviceLevelUpdated = true
      }
    },
    breachHours: {
      get() {
        return this.thresholdValue(this.serviceLevelBreachThreshold, this.sla && this.sla.inBreachThreshold, "hours")
      },
      set(newHrs) {
        this.serviceLevelBreachThreshold.hours = newHrs
        this.serviceLevelUpdated = true
      }
    },
    breachMinutes: {
      get() {
        return this.thresholdValue(this.serviceLevelBreachThreshold, this.sla && this.sla.inBreachThreshold, "minutes")
      },
      set(newMins) {
        this.serviceLevelBreachThreshold.minutes = newMins
        this.serviceLevelUpdated = true
      }
    },
    breachTask: {
      get() {
        return this.thresholdValue(this.serviceLevelBreachThreshold, this.sla && this.sla.inBreachThreshold, "taskId")
      },
      set(newTask) {
        this.serviceLevelBreachThreshold.taskId = newTask
        this.serviceLevelUpdated = true
      }
    },
    enabled: {
      get() {
        if (typeof this.serviceLevelEnabled === "boolean") { return this.serviceLevelEnabled }
        if (this.sla) { return !!this.sla.enabled }
        return false
      },
      set(newState) {
        this.serviceLevelEnabled = newState
        this.serviceLevelUpdated = true
      }
    },
    buckets() {
      return this.bucketsFromCaseTypes(this.caseTypes)
    },
    tasks() {
      return this.tasksForBucket(this.caseTypes, this.serviceLevelBucket)
    }
  },
  created() { this.prepareData() },
  watch: { sla() { this.prepareData() } },
  methods: {
    thresholdValue(localThreshold, slaThreshold, field) {
      if (localThreshold && localThreshold[field] != null) { return localThreshold[field] }
      if (slaThreshold && slaThreshold[field] != null) { return slaThreshold[field] }
      return 0
    },
    bucketsFromCaseTypes(caseTypes) {
      const buckets = []
      const types = caseTypes && Array.isArray(caseTypes) ? caseTypes : []
      for (const caseType of types) {
        if (!caseType) { continue }
        buckets.push({ header: caseType.name })
        const typeBuckets = caseType.buckets && Array.isArray(caseType.buckets) ? caseType.buckets : []
        buckets.push(...typeBuckets)
      }
      return buckets
    },
    tasksForBucket(caseTypes, bucketId) {
      let tasks = []
      const types = caseTypes && Array.isArray(caseTypes) ? caseTypes : []
      if (bucketId) {
        for (const caseType of types) {
          if (!caseType || !caseType.buckets || !Array.isArray(caseType.buckets)) { continue }
          const bucket = caseType.buckets.find((b) => b && parseInt(b.id, 10) === parseInt(bucketId, 10))
          if (bucket) {
            const tasklists = caseType.tasklistTemplates && Array.isArray(caseType.tasklistTemplates) ? caseType.tasklistTemplates : []
            for (const tasklist of tasklists) {
              if (tasklist && tasklist.tasks && Array.isArray(tasklist.tasks)) {
                tasks = tasks.concat(tasklist.tasks)
              }
            }
          }
        }
      }
      if (tasks.length === 0) {
        return [{ id: -1, description: "Tasks not found!" }]
      }
      return tasks
    },
    prepareData() {
      if (!this.sla) { return }
      this.serviceLevelName = this.sla.name
      this.serviceLevelBucket = this.sla.bucketId
      this.serviceLevelJeopardyThreshold = this.sla.inJeopardyThreshold || { days: 0, hours: 0, minutes: 0, taskId: 0 }
      this.serviceLevelBreachThreshold = this.sla.inBreachThreshold || { days: 0, hours: 0, minutes: 0, taskId: 0 }
      this.serviceLevelEnabled = !!this.sla.enabled
    },
    updateSLA() {
      const changes = []
      changes.push({ index: this.slaIndex, label: "name", data: this.serviceLevelName })
      changes.push({ index: this.slaIndex, label: "bucketId", data: this.serviceLevelBucket })
      changes.push({ index: this.slaIndex, label: "inJeopardyThreshold", data: this.serviceLevelJeopardyThreshold })
      changes.push({ index: this.slaIndex, label: "inBreachThreshold", data: this.serviceLevelBreachThreshold })
      changes.push({ index: this.slaIndex, label: "enabled", data: this.serviceLevelEnabled })
      this.$emit("sla-update", changes)
      this.serviceLevelUpdated = false
    },
    deleteSLA() {
      this.$emit("sla-delete", this.slaIndex)
    }
  }
}
</script>
